export default __webpack_public_path__ + "static/media/cityscapes.333e5600.jpg";